import React from 'react'
import LoginLayout from 'components/LoginLayout'

import LoginForm from './Form'

export default function LoginPage() {
  return (
    <LoginLayout
      showSignupLink
      tagline="Welcome back, sign in to continue"
      className="grui pt-12 min-vh-100 h-auto"
    >
      <LoginForm />
    </LoginLayout>
  )
}
